import utils from '../../utils';

const WildEmitter = utils.WildEmitter;
const mockconsole = utils.mockconsole;

function ctor(componentName, opts) {
    const that = this;
    opts = opts || {};

    for (let item in opts) {
        if (Object.prototype.hasOwnProperty.call(opts, item)) {
            this.config[item] = opts[item];
        }
    }

    this.logger = (function () {
        if (opts.debug) {
            return opts.logger || console;
        } else {
            return opts.logger || mockconsole;
        }
    })();

    WildEmitter.call(this);

    if (this.config.debug) {
        this.on('*', function (event, val1, val2) {
            that.logger.log(componentName + ' event:', event, val1, val2);
        });
    }
}

export default ctor;
